module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-circle-o-notch",
    style: ({
      color: _vm.skinColor.replace(/\sl[\S\s]+/, '')
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c48da380"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleLoading/ArticleLoading.vue
// module id = 336
// module chunks = 4